import { IClientConfig, IClientConfigV2 } from 'types/appTypes';

const isClient2Config = (
  config: IClientConfigV2 | IClientConfig | null,
): config is IClientConfigV2 => {
  return (config as IClientConfigV2).version === '2.0';
};

export default isClient2Config;
